import styled from "styled-components";
import { COLORS } from "../../shared";
import { MEDIA_QUERY } from "../../entities/Common";

export const BoxStyled = styled.div`
  background: ${COLORS.WHITE};
  box-shadow: 20px 3px 20px #00000029;
  padding: 20px;
  padding-bottom: 40px;
  box-sizing: border-box;
  height: 100%;
  min-height: inherit;
  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    padding: 15px 10px;
    box-shadow: none;
    &.no-space {
      padding: 0;
    }
  }
`;
